import React, { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

export default function TextBlockModal({ open, onCancel, onSave, initialValues = null }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const isEdit = Boolean(initialValues?.id);

    useEffect(() => {
        if (!open) return;
        form.setFieldsValue({
            title: initialValues?.title ?? '',
            description: initialValues?.description ?? '',
        });
    }, [open, initialValues, form]);

    const handleOk = async () => {
        let values;
        try {
            values = await form.validateFields();
        } catch {
            return;
        }
        onSave({
            title: values.title.trim(),
            description: values.description?.trim() || null,
        });
        form.resetFields();
    };

    return (
        <Modal
            open={open}
            title={isEdit ? t('Edit text section') : t('Add text section')}
            onCancel={() => { form.resetFields(); onCancel(); }}
            onOk={handleOk}
            okText={isEdit ? t('Save') : t('Insert')}
            destroyOnClose
            width={520}
        >
            <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
                <Form.Item
                    name="title"
                    label={t('Title')}
                    rules={[{ required: true, message: t('Enter a title') }]}
                >
                    <Input size="large" placeholder={t('Section heading')} autoFocus />
                </Form.Item>
                <Form.Item name="description" label={t('Description')}>
                    <Input.TextArea
                        rows={4}
                        placeholder={t('Supporting text shown below the title')}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}
